JUR.CustomCommands = (function () {
    /*
        Script criado para possibilitar a abertura de links em uma nova aba.
        Motivação: Alguns tribunais podem identificar a abertura da plataforma em elementos HTML terceiros e bloquear o acesso. Exemplo: TRT.
        Solução: Alterar o evento do botão de abertura de URL para abrir o link em nova guia do navegador.
    */
    const configureNewTabURLCommands = function () {
        let commands = $('.new-tab-grid-url');
        if (commands.length) {
            commands.each((index, command) => {
                let row = $(command).closest('tr');
                let field = command.classList[command.classList.length - 1].replace('url-field-', '')

                $(command).on('click', (event) => {
                    event.preventDefault();

                    let rowColumn = $(row).find(`td[data-field="${field}"]`);
                    if (!rowColumn.length) {
                        alert(`O campo "${field}" não foi identificado na grid!`);
                    }

                    let link = $(rowColumn).text();
                    if (link) {
                        window.open(link, '_blank');
                    }
                })
            });
        }
    }

    const initImplementation = function () {
        configureNewTabURLCommands();
    };

    return {
        init: initImplementation,
    }
})();

$(document).ready(function () {
    JUR.CustomCommands.init();
});